import type { LoginSchema } from '@labi-api-libs/schemas'
import { httpClient } from '@/services/http/httpClient'
import { Actors } from '@/types/actors'

import type { User } from '../../usersService/types'

export type LoginResponse = {
  token: string
  user: User
}

export async function login({
  registration,
  password,
}: LoginSchema): Promise<LoginResponse> {
  const { data } = await httpClient.post('/users/sessions/login', {
    registration,
    password,
  })

  return {
    token: data.token,
    user: {
      id: data.user.id,
      registration: data.user.registration,
      isAdmin: data.user.isAdmin,
      isProjectAdmin: data.user.isProjectAdmin,
      name: data.user.name,
      ...(data.user.email && {
        email: data.user.email,
      }),
      ...(data.user?.image && {
        profilePhoto: data.user?.image,
      }),
      ...(data.user.area && {
        area: {
          id: data.user.area.id,
          name: data.user.area.name,
        },
      }),
      isFirstAccess: data.user.firstAccess === null,
      isAcceptedTerms: !!data.user.acceptedTerms,
      role:
        data.user.isManager || data.user.isAdmin
          ? Actors.MANAGER
          : Actors.IDEATOR,
      rank: data.user.rank ?? 0,
      points: data.user.points ?? 0,
      passwordChangeRequired: data.user.passwordChangeRequired,
    },
  }
}
